/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';

/**
 * 
 * @export
 * @interface Paging
 */
export interface Paging {
    /**
     * 
     * @type {Command}
     * @memberof Paging
     */
    command?: Command;
    /**
     * 
     * @type {number}
     * @memberof Paging
     */
    first: number;
    /**
     * 
     * @type {number}
     * @memberof Paging
     */
    length: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof Paging
     */
    rowsPerPageOptions: Array<number>;
}

/**
 * Check if a given object implements the Paging interface.
 */
export function instanceOfPaging(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "first" in value;
    isInstance = isInstance && "length" in value;
    isInstance = isInstance && "rowsPerPageOptions" in value;

    return isInstance;
}

export function PagingFromJSON(json: any): Paging {
    return PagingFromJSONTyped(json, false);
}

export function PagingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Paging {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'command': !exists(json, 'command') ? undefined : CommandFromJSON(json['command']),
        'first': json['first'],
        'length': json['length'],
        'rowsPerPageOptions': json['rowsPerPageOptions'],
    };
}

export function PagingToJSON(value?: Paging | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'command': CommandToJSON(value.command),
        'first': value.first,
        'length': value.length,
        'rowsPerPageOptions': value.rowsPerPageOptions,
    };
}

